import { render, staticRenderFns } from "./59baoyevideo3.vue?vue&type=template&id=0cb446d7&"
import script from "./59baoyevideo3.vue?vue&type=script&lang=js&"
export * from "./59baoyevideo3.vue?vue&type=script&lang=js&"
import style0 from "./59baoyevideo3.vue?vue&type=style&index=0&id=0cb446d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports